/* jshint -W033 */
import Parse from 'parse'
import moment from 'moment-timezone'

import User from './User'
import Category from './Category'
import Service from './Service'

moment.tz.setDefault('America/Mexico_City');

class Appointment extends Parse.Object {

  constructor() {
    super('Appointment');
  }

  //-- Roles

  static roleUser = "6fFJtMcw4U"
  static roleProfessional = "4aYcG3DVXG"

  get dateCalendar() {
    return moment(this.get('date')).format('YYYY-MM-DD HH:mm:ss')
  }

  get date() {
    return moment(this.get('date')).format('dddd DD MMMM, YYYY')
  }

  get hour() {
    return moment(this.get('date')).format('HH:mm:ss A')
  }

  get hourBlocked() {
    return this.get('date')
  }

  get cancelDate() {
    return this.get('cancelDate')
  }

  //get service(){
  //return this.get('service.name')
  //}

  get finalAmount() {
    return this.get('finalAmount')
  }

  get professional() {
    return this.get('professional')
  }

  get professionalName() {
    return this.get('professional.name')
  }

  get status() {
    return this.get('status')
  }

  get comment() {
    return this.get('comments')
  }

  get commentServicio() {
    return this.get('ratingComment')
  }

  get rating() {
    return this.get('ratingService')
  }

  get ratingProfessional() {
    return this.get('ratingProfessional')
  }

  get service() {
    return this.get('service')
  }

  get references() {
    return this.get('references')
  }


  get statusDescription() {
    switch (this.status) {
      case 0: return 'Por asignar'
      case 1: return 'Asignado'
      case 2: return 'Concluido'
      case 3: return 'Cancelado'
    }
  }

  get statusDescriptionColor() {
    switch (this.status) {
      case 0: return '#28a745' //verde
      case 1: return '#ffc107' //amarillo
      case 2: return '#007bff' //azul
      case 3: return '#ee7979' //red
    }
  }

  //-- Detail Info

  static detail(id) {
    //console.log(id)

    let query = new Parse.Query(this)
    query.include(['service', 'address'])

    return query.get(id)
  }


  static assignHour(paramsa) {
    console.log(paramsa)

    let id = paramsa.appointmentId
    let hour = paramsa.hourId

    let pc = Appointment.createWithoutData(id)
    pc.set("date", moment(hour * 1000).toDate())

    return pc.save()


    /*var user = Parse.Object.extend("_User");
    
    var pointer = new user();
    pointer.id = params.userId;

    let pc = Appointment.createWithoutData(params.appointmentId)
    pc.set("professional", pointer)

    return pc.save()*/

    /*let params = {
      appointment_id: paramsa.appointmentId,
      professional_id: paramsa.userId
    }

    return Parse.Cloud.run('adminAssignProfessional', params)*/

  }


  static assign(paramsa) {

    /*var user = Parse.Object.extend("_User");
    
    var pointer = new user();
    pointer.id = params.userId;

    let pc = Appointment.createWithoutData(params.appointmentId)
    pc.set("professional", pointer)

    return pc.save()*/

    let params = {
      appointment_id: paramsa.appointmentId,
      professional_id: paramsa.userId
    }

    return Parse.Cloud.run('adminAssignProfessional', params)

  }


  //-- Assign

  static assign(paramsa) {

    /*var user = Parse.Object.extend("_User");
    
    var pointer = new user();
    pointer.id = params.userId;

    let pc = Appointment.createWithoutData(params.appointmentId)
    pc.set("professional", pointer)

    return pc.save()*/

    let params = {
      appointment_id: paramsa.appointmentId,
      professional_id: paramsa.userId
    }

    return Parse.Cloud.run('adminAssignProfessional', params)

  }


  //-- Relations and pointers

  loadUser(appo) {

    var query = new Parse.Query('_User');
    return query.get(appo.user.id)
  }

  loadAddress(appo) {
    var query = new Parse.Query('Address');
    return query.get(appo.address.id)
  }

  loadCards(appo) {
    var query = new Parse.Query('Card');
    return query.get(appo.card.id)
  }


  get user() {
    return this.get('user')
  }

  get fullname() {
    return `${this.get('name')} ${this.get('lastname').slice(0, 1).toUpperCase()}.`.replace(/ /g, '\u00a0')
  }

  get data() {
    return this.get('data')
  }

  get dateString() {
    return moment(this.date).format('DD MMM YYYY, hh:mm A').replace(/ /g, '\u00a0')
  }

  get client() {
    return this.user.unmaskedFullname
  }

  static count() {
    return new Parse.Query(this)
      .count()
  }

  static loadDetailStylist(userId) {
    let query = new Parse.Query(this)
    query.descending('date')
    query.include(['service'])
    query.equalTo('professional', { "__type": "Pointer", "className": "_User", "objectId": userId });

    return query.find()
  }
  static load(limit = 2000, skip = 0) {

    let query = new Parse.Query(this)

    query.limit(limit)
    query.skip(skip)
    query.ascending('status')
    query.addDescending('date')

    query.include(['user', 'location', 'promocode', 'service'])
    /*query.select([
      'user',
      'status',
      'data',
      'cancelDate',
      'date',
      'ratingComment',
      'ratingService',
      'ratingProfessional',
      'comments',
      'professional',
      'service.name',
      'finalAmount',
      'service.order',
      'service.minDuration',
      'service.maxDuration',
      'service.category'
    ])*/

    return query.find()
  }

  static loadReport(limit = 2000, skip = 0, period) {

    let query = new Parse.Query(this)

    query.limit(limit)
    query.skip(skip)
    query.ascending('date')
    query.equalTo('status', 2)
    //Buscar por stylist query.equalTo('user', { "__type": "Pointer", "className": "_User", "objectId": userId });
    if (period) {
      query.greaterThanOrEqualTo('date', period.start)
      query.lessThanOrEqualTo('date', period.end)
    }

    query.include(['user', 'location', 'service'])
    query.select([
      'user',
      'user.name',
      'user.lastname',
      'user.username',
      'status',
      'data',
      'date',
      'ratingComment',
      'ratingService',
      'ratingProfessional',
      'comments',
      'professional',
      'service.name',
      'finalAmount'
    ])
    return query.find()
  }

  static loadReportWithPameters(period = null, category = null, service = null, stylist = null, limit = 2000, skip = 0) {

    let query = new Parse.Query(this)

    query.limit(limit)
    query.skip(skip)
    query.ascending('date')
    query.equalTo('status', 2)

    if (period.start != "" && period.end != "") {
      query.greaterThanOrEqualTo('date', period.start)
      query.lessThanOrEqualTo('date', period.end)
    }

    if (service) {
      query.equalTo('service', Service.createWithoutData(service))
    }

    if (stylist) {
      query.equalTo('professional', User.createWithoutData(stylist));
    }

    if (category) {
      var innerQuery = new Parse.Query(Service)
      innerQuery.equalTo('category', Category.createWithoutData(category))
      query.matchesQuery('service', innerQuery)
    }

    query.include(['user', 'location', 'service'])
    query.select([
      'user',
      'user.name',
      'user.lastname',
      'user.username',
      'status',
      'data',
      'date',
      'ratingComment',
      'ratingService',
      'comments',
      'professional',
      'service.name',
      'finalAmount'
    ])
    return query.find()
  }

  static loadReportWithPametersStylist(stylist = null, limit = 2000, skip = 0) {

    let query = new Parse.Query(this)

    query.limit(limit)
    query.skip(skip)
    query.ascending('date')

    if (stylist) {
      query.equalTo('professional', { "__type": "Pointer", "className": "_User", "objectId": stylist });
    }

    return query.find()
  }


  static loadWithPromocode(promocode, limit = 1000, skip = 0) {
    let query = new Parse.Query(this)
    query.limit(limit)
    query.skip(skip)
    query.descending('date')
    query.equalTo('promocode', promocode)

    query.include(['user', 'location'])
    query.select([
      'user',
      'status',
      'data',
      'date',
      'comment',
      'paymentResponse',
      'location.area',
      'location.fullname',
      'location.location'
    ])

    return query.find()
  }

  static loadCommented(limit = 1000, skip = 0) {
    let query = new Parse.Query(this)
    query.limit(limit)
    query.skip(skip)
    query.descending('date')
    query.exists('ratingComment')
    query.include(['user', 'location'])
    query.select([
      'user',
      'status',
      'date',
      'data',
      'comment',
      'ratingComment',
      'ratingService',
      'location.area',
      'location.fullname',
      'location.location'
    ])
    return query.find()
  }

  //--- Search
  static filter(content, limit = 500, skip = 0) {

    if (content == "finalAmount") {
      return new Parse.Query(this)
        .limit(limit)
        .skip(skip)
        .ascending('finalAmount')
        .find()
    }

    if (content == "dateAsc") {
      return new Parse.Query(this)
        .limit(limit)
        .skip(skip)
        .descending('date')
        .find()
    }

    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .ascending('date')
      .find()

  }

  static loadfilterTable(id, limit = 2000, skip = 0,) {
    let query = new Parse.Query(this)
    query.limit(limit)
    query.skip(skip)
    query.ascending('status')
    query.addDescending('date')
    query.include(['user', 'location', 'promocode', 'service'])
    query.select([
      'user',
      'status',
      'data',
      'cancelDate',
      'date',
      'ratingComment',
      'ratingService',
      'ratingProfessional',
      'comments',
      'professional',
      'service.name',
      'finalAmount',
      'service.order',
      'service.minDuration',
      'service.maxDuration'
    ])
    query.equalTo('status', id)
    return query.find()
  }

  static finalService(id) {
    let params = {
      appointment_id: id
    }

    return Parse.Cloud.run('adminFinishAppointment', params)
  }

  //--- Cloud Functions

  static cancelData(id) {
    let params = {
      appointment_id: id
    }

    return Parse.Cloud.run('adminCancelAppointment', params)
  }

  dump() {
    console.log(this)
  }
}

export default Appointment
